---
title: E-posta ve posta kutusu kurulumu
parent: Belgeler
parentHref: /docs
---

# E-posta kutunuzu ayarlama

TOBY planınız, alan adınıza uygun profesyonel bir e-posta adresi (örneğin, info@sizin-alanadi.de) ile **15 GB posta kutusu (Maxi-Postfach)** ve sınırsız e-posta yönlendirme adresi içerir. Daha fazla posta kutusuna veya ek depolama alanına mı ihtiyacınız var? İstediğiniz zaman 15 GB'lık bir posta kutusu daha ekleyebilirsiniz — bkz. [fiyat listesi](/tr/pricing).

## 1. TOBY'de posta kutunuzu oluşturun

1. TOBY'de **Ayarlar → E-posta** bölümünü açın.
2. İstediğiniz adresi seçin (info@, merhaba@ veya iletisim@ gibi) ve posta kutusunu oluşturun.
3. **Şifrenizi kopyalayın:** TOBY, oluşturma işleminden hemen sonra oluşturulan posta kutusu şifrenizi bir kez gösterir. Pencereyi kapatmadan önce kopyalayın veya kaydedin. (Şifrenizi kaybederseniz, **Ayarlar → E-posta** altında tek tıkla yeni bir şifre oluşturabilirsiniz — mevcut e-postalarınız güvende kalır.)

## 2. Tarayıcınızda e-posta okuma ve gönderme (Webmail)

Posta kutunuzu herhangi bir bilgisayar veya telefon tarayıcısından uygulama yüklemeden açabilirsiniz:

- **Webmail adresi:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Kullanıcı adı:** tam e-posta adresiniz (örn. info@sizin-alanadi.de)
- **Şifre:** **Ayarlar → E-posta** bölümündeki posta kutusu şifreniz

## 3. Telefonunuzu veya bilgisayarınızı bağlayın (IMAP & SMTP)

**Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** veya **Thunderbird** ile e-posta okumak ve göndermek için posta uygulamanıza yeni bir **IMAP** hesabı ekleyin ve aşağıdaki sunucu ayarlarını girin:

| Ayar | Değer |
| --- | --- |
| **Hesap türü** | IMAP |
| **E-posta adresi / Kullanıcı adı** | Tam e-posta adresiniz (örn. info@sizin-alanadi.de) |
| **Şifre** | Ayarlar → E-posta bölümündeki posta kutusu şifreniz |
| **Gelen posta sunucusu (IMAP)** | mail.tobysite.com |
| **Gelen port** | 993 (SSL/TLS) |
| **Giden posta sunucusu (SMTP)** | mail.tobysite.com |
| **Giden port** | 465 (SSL/TLS) veya 587 (STARTTLS) |

> **Önemli:** Gelen (IMAP) ve giden (SMTP) sunucu için kullanıcı adı olarak **tam e-posta adresinizi** (@sizin-alanadi.de dahil) girdiğinizden emin olun.

### iPhone ve iPad'de adım adım (iOS Mail)

1. iPhone **Ayarlar** uygulamasını açın → **Uygulamalar** → **Mail** → **Mail Hesapları** → **Hesap Ekle** → **Diğer** → **Mail Hesabı Ekle**.
2. Adınızı, tam e-posta adresinizi, posta kutusu şifrenizi ve kısa bir açıklama girin. **İleri**'ye dokunun.
3. Üstte **IMAP** seçili olarak bırakın.
4. **Gelen Posta Sunucusu** ve **Giden Posta Sunucusu** altında Ana Bilgisayar Adı olarak mail.tobysite.com, Kullanıcı Adı olarak tam e-posta adresinizi ve posta kutusu şifrenizi girin.
5. **İleri**'ye ve ardından **Kaydet**'e dokunun.

### Android'de adım adım (Gmail uygulaması)

1. **Gmail** uygulamasını açın, sağ üstteki profil resminize dokunun → **Başka bir hesap ekle** → **Diğer**.
2. Tam e-posta adresinizi girin ve **Manuel ayar** → **Kişisel (IMAP)**'a dokunun, ardından şifrenizi girin.
3. **Gelen sunucu** için sunucuyu mail.tobysite.com, portu 993 ve güvenlik türünü SSL/TLS olarak ayarlayın.
4. **Giden SMTP sunucusu** için sunucuyu mail.tobysite.com, portu 465 (SSL/TLS) olarak ayarlayın ve **Oturum açma gerektir** seçeneğinin tam e-posta adresinizle etkinleştirildiğinden emin olun.
5. Bitirmek için **İleri**'ye dokunun.

Sonraki: [Bülten ve duyurular](/tr/docs/newsletter).
